import { ActionCode, Page } from './enums';

type PageActionCodes = Partial<{ [TKey in Page]: ActionCode[] }>;

const pageRequiredActionCodes: PageActionCodes = {
  [Page.Anchor]: [ActionCode.SECRETARY_USER_CODE, ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.BankHolidays]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.BankHolidayDates]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.Duties]: [
    ActionCode.ADMIN_CODE,
    ActionCode.SUPER_ADMIN_CODE,
    ActionCode.PHARMACY_USER_CODE,
    ActionCode.SECRETARY_USER_CODE,
  ],
  [Page.DutyAssignment]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE],
  [Page.Exchanges]: [
    ActionCode.ADMIN_CODE,
    ActionCode.SUPER_ADMIN_CODE,
    ActionCode.PHARMACY_USER_CODE,
    ActionCode.SECRETARY_USER_CODE,
  ],
  [Page.Groups]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE],
  [Page.GroupPage]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE],
  [Page.Planner]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.Pharmacies]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE],
  [Page.CalendarComparisonPage]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE],
  [Page.PharmacyPage]: [
    ActionCode.ADMIN_CODE,
    ActionCode.SUPER_ADMIN_CODE,
    ActionCode.SECRETARY_USER_CODE,
    ActionCode.PHARMACY_USER_CODE,
  ],
  [Page.SecretariatDashboard]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE],
  [Page.Secretariats]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE],
  [Page.Transfers]: [
    ActionCode.ADMIN_CODE,
    ActionCode.SUPER_ADMIN_CODE,
    ActionCode.PHARMAMOVE_USER_CODE,
    ActionCode.SECRETARY_USER_CODE,
  ],
  [Page.Diagnostic]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE],
  [Page.SecretariatPage]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE],
  [Page.SystemStatusPage]: [ActionCode.SUPER_ADMIN_CODE],
  [Page.Users]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.UserPage]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
};

export default pageRequiredActionCodes;
